import Checkbox from "@mui/material/Checkbox";
import { ComponentProps } from "../types";

function Component({ component }: ComponentProps) {
	return <Checkbox key={component.id} />;
}

export default Component;
